import $ from 'jquery';

$(function() {
  $(".js-about-lazy-img").lazy({
    bind: 'event',
    effect: 'fadeIn',
    effectTime: 500,
    threshold: 0
  });
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/about/index.js